import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { useAuthContext } from '@myphx-engineering/auth/client';
import { Box, Button } from '@myphx-engineering/phx-design-system';

import { useAppMaintenanceStatus } from '../../hooks/use-app-maintenance-status';

export const SignUpButton = () => {
    const { t } = useTranslation();
    const { disableAuthFlows, signUp } = useAuthContext();
    const location = useLocation();
    const { isMaintenanceActive } = useAppMaintenanceStatus();

    return (
        <Box mr="sm">
            <Button
                size="sm"
                disabled={isMaintenanceActive || disableAuthFlows}
                onClick={() => signUp(location.pathname)}
            >
                {t('unauth.header.signUp')}
            </Button>
        </Box>
    );
};
